//@flow
import { call, put, takeLatest, all } from "redux-saga/effects";

import {
  LIBRARY_GET_RECOMMENDED_REQUESTING,
  LIBRARY_GET_RECOMMENDED_ERROR,
  LIBRARY_GET_RECOMMENDED_SUCCESS,
  LIBRARY_GET_ALL_SUCCESS,
  LIBRARY_GET_ALL_ERROR,
  LIBRARY_GET_ALL_REQUESTING,
  LIBRARY_GET_PREMIUM_REQUESTING,
  LIBRARY_GET_PREMIUM_ERROR,
  LIBRARY_GET_PREMIUM_SUCCESS,
  LIBRARY_SUBMIT_TOPIC_FEEDBACK_REQUESTING,
  LIBRARY_SUBMIT_TOPIC_FEEDBACK_SUCCESS,
  LIBRARY_SUBMIT_TOPIC_FEEDBACK_ERROR,
} from "./constants";

import i18n from "../../i18n";
import { fetchApi } from "../api";
import { showAlert } from "../profileSettings/actions";

const endPoints = {
  getAllCampaigns: "/v1/campaigns/library/all",
  getRecommendedCampaigns: "/v1/campaigns/library/recommended",
  getPremiumCampaigns: "/v1/campaigns/library/premium",
  submitLibraryFeedback: "/v1/library-feedbacks",
};

const getAllCampaignsApi = data => {
  const { limit, page, clientId } = data;
  return fetchApi(
    `${endPoints.getAllCampaigns}?clientId=${clientId}&page=${page}&limit=${limit}`,
    {},
    "get",
  );
};

const getPremiumCampaignsApi = data => {
  const { limit, page, clientId } = data;
  return fetchApi(
    `${endPoints.getPremiumCampaigns}?clientId=${clientId}&page=${page}&limit=${limit}`,
    {},
    "get",
  );
};

const getRecommendedCampaignsApi = data => {
  const { limit, page, clientId, userId } = data;
  return fetchApi(
    `${endPoints.getRecommendedCampaigns}?clientId=${clientId}&userId=${userId}&page=${page}&limit=${limit}`,
    {},
    "get",
  );
};

const submitLibraryFeedbackApi = data => {
  return fetchApi(endPoints.submitLibraryFeedback, data, "post");
};

function* getRecommendedCampaignsFlow(action) {
  try {
    const response = yield call(getRecommendedCampaignsApi, action.payload);
    yield put({ type: LIBRARY_GET_RECOMMENDED_SUCCESS, payload: response });
  } catch (error) {
    console.log(error);
    yield put({ type: LIBRARY_GET_RECOMMENDED_ERROR, payload: error });
  }
}

function* getPremiumCampaignsFlow(action) {
  try {
    const response = yield call(getPremiumCampaignsApi, action.payload);
    yield put({ type: LIBRARY_GET_PREMIUM_SUCCESS, payload: response });
  } catch (error) {
    console.log(error);
    yield put({ type: LIBRARY_GET_PREMIUM_ERROR, payload: error });
  }
}

function* getAllCampaignsFlow(action) {
  try {
    const response = yield call(getAllCampaignsApi, action.payload);
    yield put({ type: LIBRARY_GET_ALL_SUCCESS, payload: response });
  } catch (error) {
    console.log(error);
    yield put({ type: LIBRARY_GET_ALL_ERROR, payload: error });
  }
}

function* submitFeedbackFlow(action) {
  try {
    const response = yield call(submitLibraryFeedbackApi, action.payload);
    yield put({
      type: LIBRARY_SUBMIT_TOPIC_FEEDBACK_SUCCESS,
      payload: response,
    });
    yield put(
      showAlert({
        title: i18n.t("library-feedback-sent-title"),
        message: i18n.t("library-feedback-sent-message"),
      }),
    );
  } catch (error) {
    console.log(error);
    yield put({ type: LIBRARY_SUBMIT_TOPIC_FEEDBACK_ERROR, payload: error });
  }
}

function* trackWatcher() {
  yield all([
    takeLatest(LIBRARY_GET_ALL_REQUESTING, getAllCampaignsFlow),
    takeLatest(LIBRARY_GET_PREMIUM_REQUESTING, getPremiumCampaignsFlow),
    takeLatest(LIBRARY_GET_RECOMMENDED_REQUESTING, getRecommendedCampaignsFlow),
    takeLatest(LIBRARY_SUBMIT_TOPIC_FEEDBACK_REQUESTING, submitFeedbackFlow),
  ]);
}

export default trackWatcher;
